module.exports = __webpack_public_path__ + "images/e7968f07bc7398f778ebd67ba7fc1314.envelope.png";